import React, {Component} from 'react';
import {Col, Row, UncontrolledTooltip} from "reactstrap";
import {getMemberImage, request} from "../../util/APIUtils";
import {b64toBlob, deepCopyObject, filterTransactionTypes, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL, SERVER_IMAGE_PATH} from "../../constants";
import './Payment.css';
import {Button, DatePicker, input} from "antd";
import Select from "../../local_node_modules/react-select"
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import Dropzone from "react-dropzone";
import moment from "moment";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Maskedinput from "react-text-mask";
import FileSaver from "file-saver";

class ReceiptForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			mode: 'create',
			page: 0,
			size: 10,
			manual: false,
			loading: false,
			fieldsDisabled:false,
			isLoading:false,
			isNotOwner:false,
			isItemLoading:false,
			receipt: {
				id:null,
				receiptNo:null,
				receivedFrom:null,
				receivedBy:null,
				receiptDate:null,
				totalAmount:0,
				branchId:null,
				userId:null,
				receiptFileList:[],
				receiptItemList:[],
			}
		};
		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.saveReceipt = this.saveReceipt.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.onChangeReceiptAmount=this.onChangeReceiptAmount.bind(this);
		this.onChangeReceipt=this.onChangeReceipt.bind(this);
		this.addItem=this.addItem.bind(this);
		this.removeItem=this.removeItem.bind(this);
		this.onSelectChange = this.onSelectChange.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.getBase64 = this.getBase64.bind(this);
		this.saveFile = this.saveFile.bind(this);
		this.downloadOriginalFile = this.downloadOriginalFile.bind(this);
		this.calculate =this.calculate.bind(this);

	}

	componentDidMount() {
		if (this.props.selectedReceipt) {
			let selectedReceipt = deepCopyObject(this.props.selectedReceipt);
			let isNotOwner=(this.props.currentUser.realm!==this.props.selectedReceipt.branchId)? true : false;
			let mod = deepCopyObject(this.props.mode);
			selectedReceipt.receiptDate = (selectedReceipt.receiptDate !== null) ? moment.utc(selectedReceipt.receiptDate, "YYYY-MM-DD HH:mm:ss") : null;
			this.setState({
				mode: mod,
				receipt: selectedReceipt, isNotOwner
			})
		}
		else{
			let receipt=this.state.receipt;
			receipt.receiptItemList.push({id: null, itemDetail: null, amount: 0,transactionChannelId:1});
			this.setState({receipt});
		}
	}


	addItem(){
		let receipt=this.state.receipt;
		if(receipt.receiptItemList.length<3) {
			receipt.receiptItemList.push({id: null, itemDetail: null, amount: 0,transactionChannelId:1});
			this.setState({receipt});
		}
	}

	removeItem(){
		let receipt=this.state.receipt;
		if(receipt.receiptItemList.length>1) {
			receipt.receiptItemList.pop(receipt.receiptItemList.length);
			this.setState({receipt},()=>this.calculate());
		}
	}


	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
		let result = validateField(rule, boundary, value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangeReceipt(e) {
		this.setState({
			receipt: {
				...this.state.receipt,
				[e.target.name]: e.target.value
			}
		})
	}

	onChangeReceiptAmount(e) {
		this.setState({
			receipt: {
				...this.state.receipt,
				[e.target.name]: e.target.value.toString().substring(0,e.target.value.length-2)
			}
		})
	}

	calculate() {
		let totalAmount=0;
		let receipt=this.state.receipt;
		for(let i=0;i<receipt.receiptItemList.length;i++)
		{
			let val=receipt.receiptItemList[i].amount ? receipt.receiptItemList[i].amount.toString().replace(',','.') : 0;
			totalAmount=( parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
		}
		receipt.totalAmount=totalAmount;
		this.setState({receipt});
	}


	onChangeReceiptItemAmount(e,index) {
		let totalAmount=0;
		let receipt=this.state.receipt;
		receipt.receiptItemList[index][e.target.name]=e.target.value.toString().substring(0,e.target.value.length-2);
		for(let i=0;i<receipt.receiptItemList.length;i++)
		{
			let val=receipt.receiptItemList[i].amount ? receipt.receiptItemList[i].amount.toString().replace(',','.') : 0;
			totalAmount=( parseFloat(totalAmount) + parseFloat(val)).toFixed(2);
		}
		receipt.totalAmount=totalAmount;
		this.setState({receipt});
	}

	onChangeReceiptItem(e,index) {
		let receipt=this.state.receipt;
		receipt.receiptItemList[index][e.target.name]=e.target.value;
		this.setState({receipt});
	}

	onChangeReceiptDate(name,value) {
		let receipt=this.state.receipt;
		if(value instanceof moment){
			value = moment.utc(value.format('DD.MM.YYYY').toString() +" 00:00", "DD.MM.YYYY HH:mm");
		}
		receipt[name]=value;
		this.setState({ receipt });
	}

	saveReceipt() {
		let self = this;
		let params;
		let data;
		let message;
		let receipt = deepCopyObject(this.state.receipt);
		let validity = this.validateComponent();

		if (validity.valid ){
			self.setState({isLoading:true});
			receipt.userId=this.props.currentUser.id;
			receipt.branchId=this.props.currentUser.realm;
			receipt=trimObject(receipt);
			receipt.totalAmount=receipt.totalAmount.toString().replace(',','.');
			for(const item of receipt.receiptItemList)
			{
				item.amount=item.amount.toString().replace(',','.');
			}
			data = receipt;
			if (receipt.id === null) {
				message = 'Makbuz Başarıyla Kaydedildi.'
				params = {
					url: API_BASE_URL + "/receipt",
					data: data,
					method: 'post'
				};
			} else {
				message = 'Makbuz Başarıyla Güncellendi.'
				params = {
					url: API_BASE_URL + "/receipt",
					data: data,
					method: 'patch'
				};
			}
			request(params).then(() => {
				Alert.success(
					message, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				self.setState({isLoading:false});
				this.cancelProcess();
				self.props.handleSearch();
			}).catch(function (error) {
				self.setState({isLoading:false});
				showAxiosError(error);
			});
		}
		else{
			let message='Hatalı veya eksik alanlar var!';
			Alert.error(message, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}


	cancelProcess() {
		this.props.cancelProcess();
	}

	getBase64(file) {
		return new Promise((resolve,reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = _ => resolve(reader.result);
			reader.onerror = e => reject(e);
		});
	}


	async onDrop(acceptedFiles, rejectedFiles) {
		let self = this;
		let receipt_=this.state.receipt;
		receipt_.receiptFileList=[];
		if (!!acceptedFiles) {
			self.setState({receipt_});
			let fileList = [];
			let content= null;
			let maxLength;
			(acceptedFiles.length>=5)? maxLength=5 : maxLength=acceptedFiles.length;
			for (let i = 0; i < maxLength; i++) {
				content=await self.getBase64(acceptedFiles[i]);
				fileList.push({id:null,receipt_id:receipt_.id, content:content, name: acceptedFiles[i].name,});

			}
			receipt_.receiptFileList=fileList;
			self.setState({receipt_});
		}
	}

	saveFile(index){
		let self=this;
		let fileName;
		let fileData;
		self.setState({isItemLoading:true});
		try{
			fileData=self.state.receipt.receiptFileList[index].content.toString().substring(self.state.receipt.receiptFileList[index].content.toString().lastIndexOf(',')+1);
			fileName=self.state.receipt.receiptFileList[index].name;
			var blob = b64toBlob(fileData,'');
			FileSaver.saveAs(blob, fileName);
			self.setState({isItemLoading:false});
		}catch(error) {
			self.setState({isItemLoading: false});
			showAxiosError(error);
		}
	}

	async downloadOriginalFile(index){
		let self=this;
		let fileName;
		let receiptFileList;
		receiptFileList=self.state.receipt.receiptFileList;
		fileName=receiptFileList[index].name;
		if((fileName!==null&&fileName==="")) {
			self.setState({isItemLoading:true});
			await getMemberImage(SERVER_IMAGE_PATH+fileName).then(response => {
				receiptFileList[index].content= response.data.base64File;
				self.setState({receiptFileList});
				var blob = b64toBlob(response.data.base64File,'');
				FileSaver.saveAs(blob, fileName);
				self.setState({isItemLoading: false});
			}).catch(function (error) {
				self.setState({isItemLoading: false});
				showAxiosError(error);
			});
		}
	}

	onSelectChange(name,value) {
		let receipt = this.state.receipt;
		if (value === null) {
			receipt[name] = null
		} else {
			receipt[name] = value.value;
		}
		this.setState({receipt});
	}

	onItemSelectChange(name,value,index){
		let receipt = this.state.receipt;
		let items = receipt.receiptItemList;
		if(value===null) {
			items[index][name]=null}
		else {
			items[index][name]=value.value;
		}
		this.setState({receipt});

	}

	render() {
		console.log(this.state.receipt);
		let tReceiptDate=this.state.receipt.receiptDate ? {value:this.state.receipt.receiptDate} : {};
		const numberMask = createNumberMask({
			prefix: '',
			suffix: ' ₺',
			allowDecimal: true,
			decimalSymbol:',',
			includeThousandsSeparator:false,
		});

		//const receiptTypes=[{label:"NAKIT" ,value:"NAKIT"},{label:"HAVALE/EFT" ,value:"HAVALE_EFT"}];
		let receiptTypes=this.props.transactionTypes?filterTransactionTypes( this.props.transactionTypes,"INCOME"):[];

		return (
			<div className='financial-transaction-form-container'>
				{/* HEADER */}
				<div className='card-header'>
					<h4 className="card-title">{this.state.mode === 'create' ? 'Yeni Makbuz Oluştur' : 'Makbuz Düzenle'}</h4>
				</div>

				<div className="card-body mt-1">
					<div className="FormRenk col-sm-12">
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Kimden Alındığı: *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tReceivedFrom')}>
									<input className="form-control"
										   type="text"
										   name="receivedFrom"
										   id="tReceivedFrom"
										   maxLength="255"
										   data-vlength="1,255"
										   onBlur={this.validateField}
										   ref="tReceivedFrom"
										   value={this.state.receipt.receivedFrom}
										   onChange={(e) => this.onChangeReceipt(e)}
									/>
									{this.validateMessage('tReceivedFrom') !== "" &&
									<UncontrolledTooltip placement="right" target="tReceivedFrom" delay={0}>
										{this.validateMessage("tReceivedFrom")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Tahsil Eden: *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tReceivedBy')}>
									<input className="form-control"
										   type="text"
										   name="receivedBy"
										   id="tReceivedBy"
										   maxLength="255"
										   data-vlength="1,255"
										   onBlur={this.validateField}
										   ref="tReceivedBy"
										   value={this.state.receipt.receivedBy}
										   onChange={(e) => this.onChangeReceipt(e)}
									/>
									{this.validateMessage('tReceivedBy') !== "" &&
									<UncontrolledTooltip placement="right" target="tReceivedBy" delay={0}>
										{this.validateMessage("tReceivedBy")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Tarih: *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tReceiptDate')}>
									<DatePicker {...tReceiptDate}
												className="basic-single"
												placeholder="Tarih seçiniz."
												disabled={this.state.fieldsDisabled}
												classNamePrefix="select"
												format= "DD.MM.YYYY"
												isClearable={true}
												isSearchable={true}
												name="receiptDate"
												id="tReceiptDate"
												ref="tReceiptDate"
												style={{ width: 250 }}
												inputProps={{'vdata': "required"}}
												onChange={(dateString) => this.onChangeReceiptDate("receiptDate",dateString)}
									/>
									{this.validateMessage('tReceiptDate') !== "" &&
									<UncontrolledTooltip placement="right" target="tReceiptDate" delay={0}>
										{this.validateMessage("tReceiptDate")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Ödeme Tipi *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tPaymentType')}>
									<Select
										className="basic-single"
										classNamePrefix="select"
										placeholder="Seçiniz."
										name="paymentType"
										style={{ width: 250}}
										inputProps={{'vdata': "required"}}
										ref="tPaymentType"
										id="tPaymentType"
										options={receiptTypes}
										onChange={(value)=>this.onSelectChange("paymentType",value)}
										value={this.state.receipt.paymentType}
									/>
									{this.validateMessage('tPaymentType') !== "" &&
									<UncontrolledTooltip placement="right" target="tPaymentType" delay={0}>
										{this.validateMessage("tPaymentType")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						{this.state.receipt.receiptItemList&&this.state.receipt.receiptItemList.map((receiptItem, index) =>

							<div className='col-sm-12 row'>
								<div className="col-sm-3">
									{(index===0)&&<label>Açıklama/Tutar: *</label>}
								</div>
								<div className="col-sm-3">
									<div className={"form-group" + this.validateClass('tItemDetail'+index)}>
										<input className="form-control"
											   type="text"
											   name={"itemDetail"}
											   id={"tItemDetail" +index}
											   maxLength="50"
											   data-vlength="1,255"
											   onBlur={this.validateField}
											   ref={"tItemDetail" +index}
											   value={receiptItem.itemDetail}
											   onChange={(e) => this.onChangeReceiptItem(e,index)}
										/>
										{this.validateMessage('tItemDetail'+index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tItemDetail"+index} delay={0}>
											{this.validateMessage("tItemDetail"+index)}
										</UncontrolledTooltip>}
									</div>
								</div>

								<div className="col-sm-3">
									<div className={"form-group" + this.validateClass('tTransactionChannel'+index)}>
										<Select
											className="basic-single"
											classNamePrefix="select"
											placeholder="Seçiniz."
											name={"tTransactionChannel" + index}
											//style={{ width: 250}}
											ref={"tTransactionChannel" + index}
											id={"tTransactionChannel" + index}
											inputProps={{'vdata': "required"}}
											options={this.props.transactionChannels}
											onChange={(value)=>this.onItemSelectChange("transactionChannelId",value,index)}
											value={receiptItem.transactionChannelId ? receiptItem.transactionChannelId : null}
										/>
										{this.validateMessage('tTransactionChannel' +index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tTransactionChannel" + index} delay={0}>
											{this.validateMessage("tTransactionChannel" +index)}
										</UncontrolledTooltip>}
									</div>
								</div>
								<div className="col-sm-3">
									<div className={"form-group" + this.validateClass('tAmount'+index)}>
										<Maskedinput className="form-control"
													 mask={numberMask}
													 type="text"
													 name={"amount"}
													 id={"tAmount"+index}
													 inputProps={{vdata: "required", vlength: '3,12'}}
													 placeholder="________,__₺"
													 onBlur={this.validateField}
													 ref={"tAmount" +index}
													 value={receiptItem.amount&&receiptItem.amount.toString().replace('.',',')+ ' ₺'}
													 onChange={(e) => this.onChangeReceiptItemAmount(e,index)}
										/>
										{this.validateMessage('tAmount'+index) !== "" &&
										<UncontrolledTooltip placement="right" target={"tAmount"+index} delay={0}>
											{this.validateMessage("tAmount"+index)}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>
						)}
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
							</div>
							<div className="col-sm-6">
								<button className='add-new-item' onClick={()=>{this.addItem()}}></button>
								<button className='remove-item' onClick={()=>{this.removeItem()}}></button>
							</div>

						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Toplam Tutar:</label>
							</div>
							<div className="col-sm-6">
								<div className="kjhkjh">
								</div>
							</div>
							<div className="col-sm-3">
								<Maskedinput className="form-control"
											 mask={numberMask}
											 type="text"
											 disabled={true}
											 name="totalAmount"
											 id="tTotalAmount"
											 placeholder="________,__₺"
											 value={this.state.receipt.totalAmount&&this.state.receipt.totalAmount.toString().replace('.',',')+ ' ₺'}
								/>
							</div>
						</div>
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Makbuz Dosyaları *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tReceiptFile')}>
									<Dropzone
										accept=".pdf, .jpeg, .jpg, .png"
										activeClassName="dropzoneActiveClass"
										className="FormRenk3 col-sm-12"
										multiple={true}
										onDrop={this.onDrop}
										id="tReceiptFile"
									>
										<div className="dropzoneInnerArea row">
											<img  alt="" className="add" src={require('../../icons8-plus-48_blue.png')}/>
											<span className="dropzoneInnerAreaText">Dosya(.pdf, .jpeg, .png) yüklemek için tıklayınız.</span>
										</div>
									</Dropzone>
									<Row>
										<Col sm="12" style={{
											paddingTop: "0px",
											paddingRight: "15px",
											paddingLeft: "15px",
											maxHeight: '500px',
											overflow: "auto"
										}}>
											<table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
												<thead>
												<tr style={{backgroundColor: '#ebedf0'}}>
													<th width="5%">#</th>
													<th>Dosya Adı</th>
													<th width="10%">Görüntüle</th>
												</tr>
												</thead>
												<tbody>
												{this.state.receipt.receiptFileList && this.state.receipt.receiptFileList.map((document, index) =>
													<tr key={index + "_" + document.name + "_" }>
														<td>{index + 1}</td>
														<td style={{margin: "0px", textAlign: "left"}}>{<TextOverFlowTooltip text={document.name || "-"} maxLength={30}/>}</td>
														<td style={{margin: "0px"}}>{<Button className={this.state.isItemLoading?'preview-button-loading':'preview-button'} disabled={this.state.isItemLoading}
																							 onClick={async () => {(this.state.receipt.receiptFileList[index].content!=='')
																								 ?
																								 this.saveFile(index)
																								 :
																								 await this.downloadOriginalFile(index)}}></Button>}</td>
													</tr>
												)}
												{(this.state.receipt.receiptFileList && this.state.receipt.receiptFileList.length === 0) &&
												<tr>
													<td colSpan="8">Kayıt bulunamadı</td>
												</tr>
												}

												</tbody>
											</table>
										</Col>
										<Col sm="12">
											<p style={{float: "right"}}>Toplam
												Adet: {this.state.receipt.receiptFileList ? this.state.receipt.receiptFileList.length : 0}</p>
										</Col>
									</Row>
									{this.validateMessage('tReceiptFile') !== "" &&
									<UncontrolledTooltip placement="right" target="tReceiptFile" delay={0}>
										{this.validateMessage("tReceiptFile")}
									</UncontrolledTooltip>}
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* CARD FOOTER */}
				<div className="modal-footer">
					<div className='col-sm-12 row'id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8"></div>
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									//disabled={this.state.fieldsDisabled || this.state.isNotOwner || this.state.isLoading}
									disabled="true"
									onClick={() => this.saveReceipt()}>{this.state.mode === 'create' ? 'Kaydet' : 'Güncelle'}
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


export default ReceiptForm;


// WEBPACK FOOTER //
// ./src/page/financial/ReceiptForm.js